import { render, staticRenderFns } from "./PersonalIncomeReport.vue?vue&type=template&id=3897d6a6"
import script from "./PersonalIncomeReport.vue?vue&type=script&lang=js"
export * from "./PersonalIncomeReport.vue?vue&type=script&lang=js"
import style0 from "./PersonalIncomeReport.vue?vue&type=style&index=0&id=3897d6a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports